import { useAppSelector } from '@app/redux/hooks';
import { ItemMenu } from '@app/Layout/Header/Desktop/HeaderMain/HeaderBottom/ItemMenu';
import { LinkAction } from '@app/components/shared/LinkAction';
import { MyLink } from '@app/components/ui-kit/Link';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { SearchButton } from '@app/Layout/Header/Blocks';
import { MiniLogo } from '../MiniLogo';
import { CartBlock } from '../CartBlock';
import { ButtonProfileHeader, ButtonProfile } from '@entities/Auth';

import { ButtonRecordWidget } from '@app/features/callKolesoWidget';
import styles from './Menu.module.scss';

export const Menu = (): JSX.Element => {
  const { menu, subMenuHeader } = useAppSelector(state => state.header.data.headerMenu);
  const { shortHeader } = useAppSelector(state => state.header.data);
  const resizeWindow = useWindowSizing(1200);
  return (
    <div className={styles.Container}>
      <MiniLogo />
      {menu?.slice(0, 3)?.map(item => <ItemMenu key={item.title} prefix={'sticky'} {...item} />)}
      <LinkAction className={styles.LinkAction} />
      <MyLink href="/services/shinomontaj/">ШИНОМОНТАЖ</MyLink>
      <MyLink href="/shops/">ЦЕНТРЫ</MyLink>
      {!resizeWindow && [...subMenuHeader]?.reverse()?.map(item => <ItemMenu key={item.title} prefix={'sticky'} {...item} />)}
      {!shortHeader && <SearchButton />}
      <ButtonProfileHeader themes={ButtonProfile.Short} />
      <CartBlock />
      <ButtonRecordWidget className={styles.ButtonRecordWidget} />
    </div>
  );
};
